import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useHotelState } from '../state';
import { AboutHotel } from './AboutHotel';
import { Attraction } from './Attraction';
import { Business } from './Business';
import { Channels } from './Channels';
import { Chat } from './Chat';
import { City } from './City';
import { Conference } from './Conference';
import { Conferences } from './Conferences';
import { Event } from './Event';
import { Events } from './Events';
import { GoodPractices } from './GoodPractices';
import { Home } from './Home';
import { Nearby } from './Nearby';
import { PhoneBook } from './PhoneBook';
import { Regulations } from './Regulations';
import { Rental } from './Rental';
import { Rentals } from './Rentals';
import { SpecialOffer } from './SpecialOffer';

export const App: FC = () => {
  const { hotelData } = useHotelState();
  return (
    <Routes>
      <Route path="/" index element={<Home />} />
      <Route path="/events" element={<Events />} />
      <Route path="/about-hotel" element={<AboutHotel id={hotelData.id} />} />
      <Route path="/other" element={<p>Other</p>} />
      <Route path="/good-practices" element={<GoodPractices />} />
      <Route path="/phonebook" element={<PhoneBook />} />
      <Route path="/special-offers" element={<SpecialOffer />} />
      <Route path="/city" element={<City />} />
      <Route path="/business/:id" element={<Business />} />
      <Route path="/attraction/:id" element={<Attraction />} />
      <Route path="/rentals" element={<Rentals />} />
      <Route path="/conferences" element={<Conferences />} />
      <Route path="/conference/:id" element={<Conference />} />
      <Route path="/event/:id" element={<Event />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/nearby" element={<Nearby />} />
      <Route path="/rental/:id" element={<Rental />} />
      <Route path="/regulations" element={<Regulations />} />
      <Route path="/channels" element={<Channels />} />
    </Routes>
  );
};
